import tw from "twin.macro";

export const Container = tw.section`
  text-gray-600 relative container mx-auto flex flex-wrap text-center
  md:flex-nowrap
`;
